<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="450px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <div>
            <h1 class="title">{{item.text}}</h1>
            <p class="info-tip" v-for="(ele, index) in item.list" :key="index">{{ele}}</p>
            <div class="down-btn" @click="toLogin">立即下载</div>
          </div>
          <div>
            <el-image style="width: 100%; height: 100%" fit='contain' :src="item.rightImage"></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 公告栏 start -->
    <div class="tips">
      <img class="icon-tips" :src="require('@/assets/imgs/icon-tips.gif')" />
      <marquee class="tip-text">为回馈浙江喔刷广大用户，即日起喔刷科技会员用户优惠价一律9折起</marquee>
    </div>
    <!-- 公告栏 end -->

    <!-- 软件下载 start -->
    <div class="down">
      <div>
        <h1 class="down-h1">软件下载</h1>
        <span class="down-span">办公软件、电商软件、管理软件，助您畅享软件便利</span>
      </div>

      <div class="down-list">
        <div class="list-item" v-for="(item, index) in listData" :key="index">
          <img class="list-img" :src="item.imageUrl" />
          <p v-for="(ele, index) in item.text" :key="index">{{ele}}</p>
          <el-button class="list-item-btn" type="primary" @click="toLogin" plain>立即下载</el-button>
        </div>
      </div>
    </div>
    <!-- 软件下载 end -->

    <!-- 产品介绍 start -->
    <div class="pro-info">
      <div>
        <h1 class="down-h1">强大的研发实力，安全稳定可靠的系统支持</h1>
        <span class="down-span">来自国内顶尖的技术研发团队，打造99.99%高可用软件</span>
      </div>

      <div class="info-box-title">
        <div>
          <img src="../assets/imgs/info-left.png">
        </div>
        <div>
          <div class="info-item">
            <h1 class="item-tips">安全稳定</h1>
            <p>集多年技术积累，混合云部署，云防火墙，多地互备，服务治理，弹性伸缩能力，全方位监控，为超百万商户的业务保驾护航。</p>
          </div>
          <div class="info-item">
            <h1 class="item-tips">更佳体验</h1>
            <p>BGP网络，CDN加速，单页面技术，全球领先的端技术，让你的用户无论身在全球何处，均能获得灵活流畅的更佳体验。</p>
          </div>
          <div class="info-item">
            <h1 class="item-tips">智慧高效</h1>
            <p>大数据和人工智能技术，为您提供BI报表，智能客服，精准会员营销等，智慧科技助您全面飞跃发展。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品介绍 end -->

    <!-- 占位 start -->
    <div class="nothing">
      <div>
        <h1 class="down-h1">丰富多样的应用软件</h1>
        <span class="down-span">联合服务商、开发者、合作伙伴，共建生态，服务中小企业</span>
      </div>

      <div class="dis">
        <div class="dis-item">
          <img src="../assets/imgs/icon-pc.png">
          <span>办公软件</span>
        </div>
        <div class="dis-item">
          <img src="../assets/imgs/icon-data.png">
          <span>管理软件</span>
        </div>
      </div>
    </div>
    <!-- 占位 end -->

    <!-- 用户注册 start -->
    <div class="user-box">
      <span>立即注册即可下载软件</span>
      <span class="user-btn"  @click="toUserSet">用户注册</span>
    </div>
    <!-- 用户注册 end -->

    <!-- 会员资讯 start -->
    <div class="vip-info">
      <div class="vip-info-left">
        <img src="../assets/imgs/user-left.png">
      </div>
      <div class="vip-info-right">
        <el-tabs v-model="activeName">
          <el-tab-pane label="会员资讯(仅对付费会员开放)" name="first">
            <div class="vip-right-item">
              <div class="info-date">{{beforTime}}</div>
              <div class="info-info">
                <a href="javascript::void(0)" @click="toLogin" class="info-title">在Linux下灵活使用expect脚本的小窍门（5元/条）</a>
                <p class="info-content">对于喜爱自动化的Linux系统管理员而言，一定是用过expect这个命令行工具。
                  Expect 是由 Don Libes 基于 Tcl 语言开发的，
                  并被广泛应用于交互式操作和自动化测试的场景之中，
                  它尤其适用于需要对多台服务器执行相同操作的环境中，
                  可以大幅度提高系统管理人员的工作效率
                </p>
                <div>
                  <el-button size="mini" @click="toNews('pay')" round>付费资讯</el-button>
                  <el-button size="mini" @click="toNews('fenxiang')" round>技术分享</el-button>
                </div>
              </div>
            </div>

            <div class="vip-right-item">
              <div class="info-date">{{lastTime}}</div>
              <div class="info-info">
                <a href="javascript::void(0)" @click="toLogin" class="info-title"> 微营销研讨分享会 助力企业转型电商腾飞（6元/条）</a>
                <p class="info-content">随着移动互联网时代的快速发展，移动互联网浪潮凶猛来袭，新兴营销模式微营销的出现，很多中小型企业被打了个措手不及。中...
                </p>
                <div>
                  <el-button size="mini" @click="toNews('pay')" round>付费资讯</el-button>
                  <el-button size="mini" @click="toNews('fenxi')" round>行业分析</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 会员资讯 end -->

  </div>
</template>

<script>
import banner1 from '@/assets/imgs/banner-1.png';
import banner2 from '@/assets/imgs/banner-2.png';
import banner1r from '@/assets/imgs/banner-1-right.png';
import banner2r from '@/assets/imgs/banner-2-right.png';

import list1 from '@/assets/imgs/list-1.png';
import list2 from '@/assets/imgs/list-2.png';
import list3 from '@/assets/imgs/list-3.png';
import list4 from '@/assets/imgs/list-3.png';
export default {
  data () {
    return {
      page: '/',
      form: {},
      activeName: 'first',
      beforTime: '',
      lastTime: '',
      carouselItem: [
        {
          bgcIma: banner1,
          rightImage: banner1r,
          text: '企业OA系统软件',
          list: [
            '●在现办公', '●即时下载', '●会员优惠价：6000元'
          ]
        },
        {
          bgcIma: banner2,
          rightImage: banner2r,
          text: '在线商城软件下载',
          list: [
            '●企业独立运营商城', '●助力企业快速进入移动电商时代', '●会员优惠价：1800元（不含服务器）'
          ]
        }
      ],

      listData: [
        {
          text: ['运维管理软件', '企业大数据运维管理', '会员优惠价：2000元'],
          imageUrl: list1
        },
        {
          text: ['建筑行业软件', '建筑行业实时监测软件', '会员优惠价：3000元'],
          imageUrl: list2
        },
        {
          text: ['粮牧监测软件', '农产畜牧业智能检测软件', '会员优惠价：900元'],
          imageUrl: list3
        },
        {
          text: ['船只管理软件', '远洋船只检测管理软件', '会员优惠价：3000元'],
          imageUrl: list4
        }
      ]
    }
  },

  created() {
    var day1 = new Date();
    day1.setTime(day1.getTime()-24*60*60*1000);
    this.lastTime = day1.getFullYear()+"-" + (day1.getMonth()+1) + "-" + day1.getDate();
    //今天的时间
    var day2 = new Date();
    day2.setTime(day2.getTime()-24*60*60*1000*3);
    this.beforTime = day2.getFullYear()+"-" + (day2.getMonth()+1) + "-" + day2.getDate();
  },

  methods: {
    toNews(type) {
      this.$router.push({
        path: '/news',
        query: {
          type
        }
      })
    },
    toLogin() {
      this.$router.push({
        path: '/userlogin'
      })
    },
    toUserSet() {
      this.$router.push({
        path: '/userset'
      })
    }
  },
}
</script>

<style scoped>
 .carousel-box {
   overflow: hidden;
 }
 .item-bgc {
   position: absolute;
   top: 0;
   left: 0;
   height: 100%;
 }
 .info-box {
   width: 60%;
   height: 70%;
   background-color: transparent;
   position: absolute;
   left: 50%;
   top: 100px;
   transform: translateX(-50%);
   display: flex;
 }
 .info-box div {
   flex: 1;
   color: #fff;
   font-size: 18px;
 }
 .title {
   font-size: 46px;
   padding: 20px 0;
 }
 .info-tip {
   padding: 5px 0;
 }
 .down-btn {
   width: 120px;
   text-align: center;
   padding: 10px 20px;
   border: 1px solid #fff;
   cursor: pointer;
   margin-top: 40px;
 }

  .tips {
   height: 30px;
   background-color: #fff;
   display: flex;
   align-items: center;
   padding-left: 250px;
   overflow: hidden;
  }
  .icon-tips {
    width: 20px;
    height: 20px;
  }
  .tip-text {
    width: 80%;
    color: #666;
  }

  .down,
  .pro-info,
  .nothing,
  .user-box,
  .vip-info {
    padding: 60px 250px 30px 250px;
    background-color: rgb(241, 241, 241);
    box-sizing: border-box;
  }
  .down-h1 {
    color: rgb(43, 43, 43);
    font-size: 26px;
    font-weight: bold;
  }
  .down-span {
    color: rgb(75, 75, 75);
    font-size: 18px;
  }

  .down-list {
    padding-top: 80px;
    display: flex;
    justify-content: space-between;
  }
  .list-item {
    width: 240px;
    padding: 5px 10px 10px 10px;
    background-color: #fff;
    box-sizing: border-box;
    text-align: center;
  }
  .list-img {
    width: 100%;
    padding-bottom: 30px;
  }
  .list-item p {
    padding: 5px 0;
    text-align: center;
    color: rgb(203, 203, 203);
  }
  .list-item p:nth-child(2) {
    color: rgb(33, 33, 33);
    font-size: 20px;
  }
  .list-item-btn {
    width: 150px;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .info-box-title {
    padding-top: 40px;
    display: flex;
  }
  .info-box-title div {
    flex: 1;
  }
  .info-box-title div:nth-child(2) {
    flex: 1.4;
  }
  .pro-info {
    background-image: url('../assets/imgs/infobgc.png')
  }
  .pro-info .down-h1,
  .pro-info .down-span {
    color: #fff;
  }
  .info-item {
    width: 80%;
    border-radius: 5px;
    background-image: url('../assets/imgs/itembgc.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 20px 40px;
    color: #fff;
    margin-bottom: 10px;
  }
  .info-item .item-tips {
    padding-bottom: 20px;
    font-size: 20px;
  }

  .dis {
    display: flex;
    padding-top: 30px;
  }
  .dis div {
    flex: 1;
  }
  .dis-item {
    display: flex;
    padding: 40px 30px;
    border: 1px solid #ccc;
    margin-right: 20px;
    align-items: center;
    color: rgb(33, 33, 33);
    font-size: 20px;
  }
  .dis-item img {
    margin-right: 10px;
  }

  .user-box {
    width: 100%;
    height: 140px;
    background-image: url('../assets/imgs/userbgc.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    color: #fff;
    font-size: 34px;
  }
  .user-btn {
    font-size: 20px;
    padding: 10px 20px;
    border: 1px solid #fff;
    cursor: pointer;
  }

  .vip-info {
    display: flex;
  }

  .vip-info-left {
    padding-top: 30px;
    flex: 1;
  }
  .vip-info-right {
    flex: 1.3;
    margin-left: 10px;
  }
  .vip-right-item {
    display: flex;
    padding: 20px 10px;
    border-bottom: 1px solid #ccc;
  }
  .vip-right-item:last-child {
    border-bottom: none;
  }
  .vip-right-item .info-date {
    flex: 1;
    font-size: 22px;
    display: flex;
    align-items: center;
  }
  .vip-right-item .info-info {
    flex: 4;
  }
  .info-title {
    color: #00a0e9;
    font-size: 16px;
  }
  .info-content {
    padding-top: 10px;
    color: #878787;
    line-height: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue